const r = {
  header: {
    bg: "surface",
    color: "gray.900"
  },
  card: {
    borderRadius: "lg",
    boxShadow: "e6",
    bg: "surface"
  },
  cardOutlined: {
    borderRadius: "lg",
    border: "1px",
    borderColor: "onSurface.lowEmphasis",
    bg: "surface"
  }
};
export {
  r as layerStyles
};
